import React, { useLayoutEffect } from 'react'
import { MdArrowDropDown, MdArrowDropUp } from 'react-icons/md'
import { components } from 'react-select'
import Flex from 'typescript-styled-flex'
import is from 'typescript-styled-is'

import Tooltip from '../../Tooltip/Tooltip'
import { useTranslation } from 'react-i18next'
import styled from '../../../theme'

const Wrapper = styled(Flex as any)<any>`  
  ${is('disabled')`
    cursor: not-allowed;
    opacity: 0.5; 
    
  `}
`

export const customOption = size => props => {
  const className = [
    props.selectProps.className,
    'item',
    Number(props.innerProps.id.split('-').pop()) + 1,
  ].join('-')

  const { t } = useTranslation()

  const onKeyDown = e => {
    if (props.data.disabled) {
      e.preventDefault()
      e.stopPropagation()
    }
  }

  return (
    <components.Option
      {...props}
      tabindex="-1"
      onKeyDown={onKeyDown}
      innerProps={props.data.disabled ? {} : props.innerProps}
    >
      <Tooltip
        disableHoverListener={!props.data.disabled}
        disableClickListener={!props.data.disabled}
        placement={'top'}
        title={t('BBO_3693_this_room_is_not_shared_to_widget')}
        viewportBoundary={true}
        disablePropagation={props.data.disabled}
        disableTouchListener={!props.data.disabled}
      >
        <Wrapper
          data-cy={props.data['data-cy']}
          disabled={props.data.disabled}
          className={className}
          tabindex="-1"
          row={true}
          alignCenter={true}
        >
          {props.data.icon &&
            (typeof props.data.icon === 'object' ? (
              props.data.icon
            ) : (
              <img
                alt={''}
                width={24 * size}
                height={24 * size}
                style={{
                  minHeight: `${24 * size}px`,
                  minWidth: `${24 * size}px`,
                }}
                src={props.data.icon}
              />
            ))}
          <div
            style={
              props.data.icon
                ? {
                    marginLeft: `${10 * size}px`,
                    marginTop: `${3 * size}px`,
                    minWidth: '0',
                  }
                : props.isMulti
                ? { marginLeft: `${size}px` }
                : { minWidth: '0' }
            }
          >
            {props.data.label}
          </div>
        </Wrapper>
      </Tooltip>
    </components.Option>
  )
}

export const customContainer = size => props => {
  useLayoutEffect(() => {
    const element = document.getElementsByClassName(props.selectProps.className)
    for (const el of element) {
      el.setAttribute('data-cy', props.selectProps.className)
    }
  }, [props.selectProps.className])

  return <components.ValueContainer {...props} />
}

export const customSingleValue = size => props => {
  return (
    <components.SingleValue {...props}>
      <Flex row={true} alignCenter={true} style={{ fontWeight: 500 }}>
        {props.data.icon &&
          !props.data.disableIcon &&
          (typeof props.data.icon === 'object' ? (
            props.data.icon
          ) : (
            <img
              alt={''}
              width={24 * size}
              height={24 * size}
              src={props.data.icon}
            />
          ))}
        <div
          style={
            props.data.icon
              ? { marginLeft: `${10 * size}px`, marginTop: '3px' }
              : {}
          }
        >
          {props.data.label}
        </div>
      </Flex>
    </components.SingleValue>
  )
}

export const customDropdownIndicator = size => props => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        {props.selectProps.menuIsOpen ? (
          <MdArrowDropUp size={24 * size} />
        ) : (
          <MdArrowDropDown size={24 * size} />
        )}
      </components.DropdownIndicator>
    )
  )
}
